import { NgClass } from '@angular/common';
import { computed } from '@angular/core';
import { inject } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { Component } from '@angular/core';
import { DividerComponent } from '@app/shared/components/divider.component';
import { State } from '@app/state/state';
import { ScopeIconComponent } from '@app/explore/scope-icon.component';

@Component({
  selector: 'ui-map-route-popup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="route-popup" [ngClass]="{ hidden: hide() }">
      @for (route of routes(); track route.routeId) {
        <div class="kpn-line">
          <ui-scope-icon [scope]="route.scope" />
          <span>{{ route.name }}</span>
          <span>({{ route.routeId }})</span>
        </div>
      }
      <ui-divider />
      <div class="hint">Click for further details</div>
    </div>
  `,
  styles: `
    .route-popup {
      padding: 1em;
      background-color: white;
      min-width: 20em;
      border-radius: 0.5em;
      border: 1px solid lightgray;
    }

    .hint {
      font-size: 0.8em;
    }
  `,
  imports: [DividerComponent, NgClass, ScopeIconComponent],
})
export class MapRoutePopupComponent {
  private readonly state = inject(State);

  readonly routes = computed(() => {
    const state = this.state.map.routePopupState();
    if (state) {
      return state.routes;
    }
    return [];
  });

  readonly hide = computed(() => this.routes().length === 0);
}
